$(function () {
  function editText($percent) {
    var txt = $percent.text();
    var num = txt.substr(0, 2).replace('%', '');
    var mark = txt.substr(-1, 1);
    var newtxt = num + mark;
    $percent.text(newtxt.replace('.', ''));
  }

  var interval = setInterval(function () {
    var $percent = $('.bold-ro__initial-discount-percent');
    if ($percent.lenght != 0) {
      editText($percent);
      clearInterval(interval);
    }
  }, 100);
});
